import { useTranslation } from 'react-i18next'
import { Container } from 'react-bootstrap'
import { ValidateAddress } from './validate_address'
import Header from './components/header'
import {
    HomepageTopSection,
    HomepageTopSectionMain,
    SectionContent,
    SectionImg,
    SectionRow
} from './components/styles/Homepage.styled'

export const Homepage = () => {
    const { t } = useTranslation('homepage')

    return (
        <>
            <Header />
            <Container>
                <HomepageTopSection>
                    <HomepageTopSectionMain>
                        <h1>{t('Save on your Electricity Bill')}</h1>
                        <p>
                            {t(
                                'Consolidated Texas Energy Marketplace to find the best electricity plan for your home'
                            )}
                        </p>
                        <ValidateAddress />
                    </HomepageTopSectionMain>
                </HomepageTopSection>
            </Container>
            <div style={{borderTop:'1px solid #eee'}}>
                <Container>
                    <SectionRow reverse>
                        <SectionContent>
                            <h2>{t('2,000+ Plans leaving you confused?')}</h2>
                            <p>
                                {t(
                                    'Understanding and comparing 2,000+ energy plans on your desktop creates headaches. Let our AI technology reads the fine prints and compare hundreds of plans for you. Our smart search engine fully scans the entire marketplace and refresh the plan list on daily basis to meet your needs.'
                                )}
                            </p>
                        </SectionContent>
                        <SectionImg>
                            <img src="/images/product-feature-shop.png" alt="" />
                        </SectionImg>
                    </SectionRow>
                </Container>
            </div>
        </>
    )
}
